import { component } from 'knockout-decorators'

import source from './template.html?raw'
import ExpiryIcon from '../../../images/icons/cart_expired.svg?raw'

import './style.less'

@component('cart-expiration-content', source)
export class CartModalExpirationContent {
  private expiryIcon = ExpiryIcon
}
